import { Link } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

function trackEvent(eventName: string, params: Record<string, string>) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
}

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat filter blur-sm"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/241cf1e4960c1e904acf66d6469ad21f.jpg)'
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Fiber Optik ve Güvenlik Sistemlerinde
          <span className="block mt-2 bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">
            Profesyonel Çözümler
          </span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed">
          İstanbul, Kocaeli, Sakarya ve çevre illerde 7/24 acil müdahale hizmeti ile fiber optik altyapı, güvenlik sistemleri ve endüstriyel çözümler sunuyoruz.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <a
            href="tel:+905537165561"
            onClick={() =>
              trackEvent('phone_call_click', {
                event_category: 'iletisim',
                event_label: 'hero_phone_button',
                value: '1',
              })
            }
            className="group px-8 py-4 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-phone-fill text-xl"></i>
            Hemen Ara
          </a>
          
          <a
            href="https://wa.me/905537165561?text=Merhaba, bilgi almak istiyorum"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackEvent('whatsapp_click', {
                event_category: 'iletisim',
                event_label: 'hero_whatsapp_button',
                value: '1',
              })
            }
            className="group px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-whatsapp-fill text-xl"></i>
            WhatsApp Destek
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-white">
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-2xl text-teal-400"></i>
            <span className="text-sm md:text-base">7/24 Acil Müdahale</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-2xl text-teal-400"></i>
            <span className="text-sm md:text-base">Garantili Hizmet</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-team-line text-2xl text-teal-400"></i>
            <span className="text-sm md:text-base">Uzman Ekip</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-map-pin-line text-2xl text-teal-400"></i>
            <span className="text-sm md:text-base">Geniş Hizmet Ağı</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white opacity-70"></i>
      </div>
    </section>
  );
}
